import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertChatNotFoundStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.ChatNotFound) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendChatNotFound);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({ message: 'Сообщение отправлено, но чат не открылся. Обновите страницу' }));

      const error = new GuardError({
        message: 'Первое сообщение доставлено, но бэкенд не вернул чат: рассинхрон данных',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
